// Framer Motion animációs konfigurációk

// Fade in animáció (alulról felfelé)
export const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

// Fade in (egyszerű)
export const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.4
    }
  }
};

// Stagger container (gyerek elemek egymás után animálódnak)
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3
    }
  }
};

// Scale hover animáció
export const hoverScale = {
  scale: 1.05,
  transition: {
    type: "spring",
    stiffness: 300,
    damping: 20
  }
};

// Tap animáció (gomb kattintás)
export const tapScale = {
  scale: 0.95,
  transition: {
    duration: 0.1
  }
};

// Slide in from left
export const slideInLeft = {
  hidden: {
    opacity: 0,
    x: -50
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

// Slide in from right
export const slideInRight = {
  hidden: {
    opacity: 0,
    x: 50
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

// Recipe card hover
export const cardHover = {
  y: -8,
  boxShadow: "0 12px 32px rgba(255, 105, 180, 0.3)",
  transition: {
    type: "spring",
    stiffness: 300,
    damping: 25
  }
};

// Navbar scroll animation
export const navbarScroll = {
  hidden: {
    y: -100,
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  }
};
